import { useEffect } from 'react'

import { SettingComponentProps } from '../../types/setting/type'
import { Select } from '../basics/Select'

export function SettingComponent({
  audioInputOptions,
  videoInputOptions,
  audioInputOption,
  videoInputOption,
  fetchDevices,
  save,
  onChangeAudio,
  onChangeVideo,
}: SettingComponentProps) {
  useEffect(() => {
    fetchDevices()
  }, [fetchDevices])

  return (
    <>
      <div>
        <Select
          labelText="オーディオデバイス選択"
          placeholder="オーディオデバイス選択"
          value={audioInputOption.value}
          options={audioInputOptions}
          onChange={onChangeAudio}
        />
      </div>

      <div>
        <Select
          placeholder="ビデオデバイスの選択"
          labelText="ビデオデバイスの選択"
          value={videoInputOption.value}
          options={videoInputOptions}
          onChange={onChangeVideo}
        />
      </div>
      <div>
        <button type="submit" onClick={save}>
          保存
        </button>
      </div>
    </>
  )
}
